import { render } from "./ModalDeletePost.vue?vue&type=template&id=73554d5e&scoped=true"
import script from "./ModalDeletePost.vue?vue&type=script&lang=js"
export * from "./ModalDeletePost.vue?vue&type=script&lang=js"

import "./ModalDeletePost.vue?vue&type=style&index=0&id=73554d5e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73554d5e"]])

export default __exports__